import { useMemo } from 'react';
import { alpha, Chip } from '@mui/material';
import { AppointmentStatus } from 'types/appointment';
import { APPOINTMENT_STATUS_COLORS, APPOINTMENT_STATUS_LABELS } from './constants';

interface Props {
    status: AppointmentStatus;
}

export const AppointmentStatusLabel = ({ status }: Props) => {
    const styles = useMemo(
        () => ({
            color: APPOINTMENT_STATUS_COLORS[status],
            backgroundColor: alpha(APPOINTMENT_STATUS_COLORS[status], 0.25),
            fontWeight: 500,
        }),
        [status],
    );
    return <Chip size="small" label={APPOINTMENT_STATUS_LABELS[status]} sx={styles} />;
};
